export default __webpack_public_path__ + "static/media/4.f1196fd9.webp";